import { CircleGeometry, EdgesGeometry, LineBasicMaterial, LineSegments, Mesh, MeshBasicMaterial } from 'three';

import type { ILineOptions, IMeshOptions } from '@/types';

const DEFAULT_SEGMENTS = 24;

// 分段越大圆形拟合越平滑
const SEGMENTS_SCALE = 12;

export class Circle3d {
  /**
   * 创建 3D 圆形（面）
   * @param data [x, y, z, r] three.js 坐标系
   * @param options 配置项
   * @returns
   */
  static create(data: number[], options: IMeshOptions) {
    const [x, y, z, radius] = data;
    const { color, opacity: faceOpacity, borderColor } = options;

    const segments = Math.floor(radius) * SEGMENTS_SCALE;
    const geometry = new CircleGeometry(radius, segments > DEFAULT_SEGMENTS ? segments : DEFAULT_SEGMENTS);
    const material = new MeshBasicMaterial({ color, transparent: true, opacity: faceOpacity });

    const circle = new Mesh(geometry, material);
    circle.position.set(x, y, z);
    circle.userData = { ...options };

    if (borderColor) {
      const border = new LineSegments(
        new EdgesGeometry(geometry),
        new LineBasicMaterial({
          linewidth: 1,
          color: borderColor,
        })
      );
      circle.add(border);
    }

    return circle;
  }

  /**
   * 创建 3D 圆形（线）
   * @param data [x, y, z, r] three.js 坐标系
   * @param options 配置项
   * @returns
   */
  static createLine(data: number[], options: ILineOptions) {
    const [x, y, z, radius] = data;
    const { color } = options;

    const segments = Math.floor(radius) * SEGMENTS_SCALE;
    const geometry = new CircleGeometry(radius, segments > DEFAULT_SEGMENTS ? segments : DEFAULT_SEGMENTS);

    const circleLine = new LineSegments(
      new EdgesGeometry(geometry),
      new LineBasicMaterial({
        linewidth: 1,
        color: color,
      })
    );
    circleLine.position.set(x, y, z);
    circleLine.userData = { ...options };

    return circleLine;
  }
}
